module.exports = __webpack_public_path__ + "img/ewm.6c69bb29.png";